export enum THEMES {
  DEFAULT = 'default',
  RDK = 'rdk',
  DJURENS_RATT = 'djurens_ratt',
}

export type ThemesType = `${THEMES}`
